import React, { useState } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { DelendForgotPasswordField } from "../../components/TextFields";
import UserService from "../../services/UserService";
import { styled } from "@mui/material/styles";
import LoginWave from "../../components/Vectors/LoginWave";
import { Box } from "@mui/system";
import "./ForgotPassword.css";
import DelendForgotPasswordButton from "../../components/Buttons/DelendForgotPasswordButton";
import ForgotPasswordExclamation from "../../components/Vectors/img/forgotPasswordExclamation.png";
import DelendCentralizedCircularProgress from "../../components/CircularProgress/DelendCentralizedCircularProgress";
import BrandLogo from "../../components/Vectors/BrandLogo";

const ForgotPassword = () => {
  let navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);

  const paperStyle = {
    padding: 20,
    overflow: "auto",
    width: "80vw",
    maxWidth: 460,
    margin: "12px auto",
  };

  const [user, setUser] = useState({
    username: "",
    password: "",
    errors: "",
  });

  const clearField = (propertyName) => {
    setUser({
      ...user,
      [propertyName]: "",
    });
  };

  const handleChange = (event) => {
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await UserService.forgotPassword(user);
    setLoading(false);
    if (response) {
      navigate("/email-sent");
    }
  };

  const ResponsiveLogoBox = styled("div")(({ theme }) => ({
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      paddingTop: "10vh",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: "1vh",
    },
  }));

  return (
    <React.Fragment>
      <LoginWave />
      <Box
        layout="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        style={{ width: [100, 100, 550, 550, 550], margin: "0 auto" }}
      >
        <ResponsiveLogoBox>
          <BrandLogo />
        </ResponsiveLogoBox>

        <Paper elevation={10} style={paperStyle}>
          <form onSubmit={handleSubmit}>
            <Grid container direction={"column"} spacing={6}>
              <Grid item align="center">
                <h2
                  style={{
                    color: "#5E5A81",
                    fontSize: "24px",
                    lineHeight: "32px",
                    fontWeight: "bold",
                  }}
                >
                  Problemas com sua senha?
                </h2>
                <img
                  style={{ marginTop: 18, marginBottom: 18 }}
                  height="50px"
                  alt="Esqueceu sua senha?"
                  src={ForgotPasswordExclamation}
                ></img>
                <h4>
                  Agora vamos recupera-lá!
                  <br />
                  Digite o seu CPF ou endereço de e-mail para receber um link
                  com as instruções de como recuperar a sua conta.
                </h4>
              </Grid>
              <Grid style={{ paddingTop: 24 }} container item spacing={2}>
                <Grid item xs={12}>
                  <DelendForgotPasswordField
                    label="CPF ou e-mail"
                    name="username"
                    value={user.username}
                    onChange={handleChange}
                    clear={clearField}
                    variant="standard"
                    inputProps={{
                      style: { fontSize: 12, height: 30 },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item align="center">
                {isLoading ? (
                  <DelendCentralizedCircularProgress absolute="false" />
                ) : (
                  <DelendForgotPasswordButton user={user} />
                )}
              </Grid>
              <Grid item align="center">
                <Typography>
                  <Link className="createAccount" to="/">
                    voltar para o login
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default ForgotPassword;
